import { Component, OnInit } from '@angular/core';
import {
  baseCssConfigStyle,
  BaseCssProperties,
  H1AdditionalConfig,
  IFrameAdditionalConfig,
  ProviderClass,
} from '@finxone-platform/shared/sys-config-types';
import { CachedSrcDirective } from '../../../../lib/directives/cached.src.directive';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';

@Component({
  selector: 'finxone-web-frontend-iframe-widget',
  templateUrl: './iframe-widget.component.html',
  styleUrls: ['./iframe-widget.component.scss'],
  imports: [CachedSrcDirective],
})
export class IFrameWidgetComponent implements OnInit {
  attri: IFrameAdditionalConfig;
  contentStyle: any;
  baseCssStyle: baseCssConfigStyle;
  borderStyle: baseCssConfigStyle;
  attri1: H1AdditionalConfig;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static showMargin = true;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static showPadding = true;

  iframeHeight: string;
  mergedCss: any = {};
  iframeUrl: string;

  constructor(private configService: ConfigService, public dataIn: ProviderClass<IFrameAdditionalConfig>) {}
  ngOnInit(): void {
    this.onLoadWidgetConfiguration();
  }

  private onLoadWidgetConfiguration(): void {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
    }

    this.iframeHeight = `${this.attri.widgetProperties?.['verticalHeight']}vh`;
    this.iframeUrl = this.attri.widgetProperties?.['iframeUrl'];
    const addConfig = this.configService.onGetIframeWidgetStyle(this.attri);
    this.contentStyle = addConfig?.content;

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
    ]);

    this.borderStyle = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.BORDER]);
    this.mergedCss = {
      ...this.contentStyle,
      ...this.borderStyle,
    };
  }
}
